module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left is-flex"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.loggedUser) ? _c('div', {
    staticClass: "nav-item"
  }, [_c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loggedUser))])]), _vm._v(" "), (_vm.loggedUserState != 'Активен') ? _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loggedUserState))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('tooltip', {
    attrs: {
      "label": 'beta',
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v(_vm._s(_vm.appTitle))]), _vm._v(" "), _c('strong', {
    staticClass: "admin"
  }, [_vm._v(" Личный Кабинет")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": '#/users/' + _vm.loggedId,
      "tag": "button"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "nav-item",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(2)]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Профиль пользователя")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://voicebot.doc.ivoice.online/",
      "target": "_blank",
      "tag": "button"
    }
  }, [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-wikipedia-w"
  })]), _vm._v(" "), _c('span', [_vm._v("Помощь")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  })]), _vm._v(" "), _c('span', [_vm._v("Выход")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-610f5e29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Navbar.vue
// module id = 453
// module chunks = 40